import { useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';

import { InquiryTemplateStatus } from 'dashboard/models/inquiry-template';
import { getAllTemplates } from 'dashboard/redux/selectors/organization';
import { RootState } from 'dashboard/redux/store';
import DashboardGettingStartedMobileSDKsView from 'dashboard/views/DashboardGettingStartedMobileSDKsView';
import { ApiModel } from 'lib/interfaces/api';

const DashboardGettingStartedMobileSDKsRoute = (props: PropsFromRedux) => {
  const [selectedTemplateIdx, setSelectedTemplateIdx] = useState<number>(0);
  const selectedTemplate = props.templates[selectedTemplateIdx];

  const handleTemplateSelect = (templateId: string) => {
    setSelectedTemplateIdx(props.templates.findIndex((template) => template.id === templateId));
  };

  // hide inactive Inquiry Templates from integration view
  const visibleTemplates = props.templates.filter(
    (template) =>
      template.type === ApiModel.Template ||
      (template.type === ApiModel.InquiryTemplate &&
        template.attributes.status === InquiryTemplateStatus.Active),
  );

  return (
    <DashboardGettingStartedMobileSDKsView
      handleTemplateSelect={handleTemplateSelect}
      selectedTemplate={selectedTemplate}
      templates={visibleTemplates}
    />
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    templates: getAllTemplates(state),
  };
};

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(DashboardGettingStartedMobileSDKsRoute);
